/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoNftRestoreLogListNftRestoreLogData model module.
 * @module model/LogControllerDtoNftRestoreLogListNftRestoreLogData
 * @version 1.0
 */
class LogControllerDtoNftRestoreLogListNftRestoreLogData {
    /**
     * Constructs a new <code>LogControllerDtoNftRestoreLogListNftRestoreLogData</code>.
     * @alias module:model/LogControllerDtoNftRestoreLogListNftRestoreLogData
     */
    constructor() { 
        
        LogControllerDtoNftRestoreLogListNftRestoreLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoNftRestoreLogListNftRestoreLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoNftRestoreLogListNftRestoreLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoNftRestoreLogListNftRestoreLogData} The populated <code>LogControllerDtoNftRestoreLogListNftRestoreLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoNftRestoreLogListNftRestoreLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemName')) {
                obj['itemName'] = ApiClient.convertToType(data['itemName'], 'String');
            }
            if (data.hasOwnProperty('itemQuantity')) {
                obj['itemQuantity'] = ApiClient.convertToType(data['itemQuantity'], 'Number');
            }
            if (data.hasOwnProperty('beforeMileage')) {
                obj['beforeMileage'] = ApiClient.convertToType(data['beforeMileage'], 'Number');
            }
            if (data.hasOwnProperty('afterMileage')) {
                obj['afterMileage'] = ApiClient.convertToType(data['afterMileage'], 'Number');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('durability')) {
                obj['durability'] = ApiClient.convertToType(data['durability'], 'Number');
            }
            if (data.hasOwnProperty('transactionNo')) {
                obj['transactionNo'] = ApiClient.convertToType(data['transactionNo'], 'Number');
            }
            if (data.hasOwnProperty('cost')) {
                obj['cost'] = ApiClient.convertToType(data['cost'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoNftRestoreLogListNftRestoreLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoNftRestoreLogListNftRestoreLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['itemName'] && !(typeof data['itemName'] === 'string' || data['itemName'] instanceof String)) {
            throw new Error("Expected the field `itemName` to be a primitive type in the JSON string but got " + data['itemName']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['email'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} itemId
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['itemId'] = undefined;

/**
 * @member {String} itemName
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['itemName'] = undefined;

/**
 * @member {Number} itemQuantity
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['itemQuantity'] = undefined;

/**
 * @member {Number} beforeMileage
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['beforeMileage'] = undefined;

/**
 * @member {Number} afterMileage
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['afterMileage'] = undefined;

/**
 * @member {Number} level
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['level'] = undefined;

/**
 * @member {Number} durability
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['durability'] = undefined;

/**
 * @member {Number} transactionNo
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['transactionNo'] = undefined;

/**
 * @member {Number} cost
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['cost'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoNftRestoreLogListNftRestoreLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoNftRestoreLogListNftRestoreLogData;

